import { Alert } from '@mui/material';

/** For a login no owner record points at, such as after access was removed. */
export function OwnerNotLinked() {
  return (
    <Alert severity="info">
      This login isn't connected to an owner record yet. Please ask your property manager for a new
      invitation.
    </Alert>
  );
}
